var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"margin-10"},[_c('alert-box',{attrs:{"type":"error","message":_vm.message}}),_vm._v(" "),_c('div',{staticClass:"error-cta"},[_c('ui-button',{attrs:{"size":"lg"},on:{"click":_vm.reload}},[_vm._v("\n\t\t\tReload\n\t\t")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }